import { Cookies } from 'react-cookie';

const cookies = new Cookies();
// console.log('dotenv', process.env.REACT_APP_NODE_ENV);
// .env 환경변수 쓰다 바꿔가며 빌드하는것 보다 그냥 자동으로 읽고 빌드 되는게 편해서 문제있는김에 바꿈
const currentDomain = window.location.hostname;
const currentPort = window.location.port; // 예: '3000' 또는 '3001'

let domain = '';

if (currentDomain.includes('torooc.com')) {
	domain = '.torooc.com';
} else if (currentDomain.includes('torooc.net')) {
	domain = '.torooc.net';
} else {
	domain = '.localhost';
}

export const DEFAULT_MAX_AGE = 36000; // 10시간
// export const DEFAULT_MAX_AGE = 20;

const DEFAULT_OPTIONS = {
	/** 배포할때 다른 torooc.com 하위 도메인에서도 쿠키를 전달 할 수 있게 함 */
	domain,
	path: '/',
	maxAge: DEFAULT_MAX_AGE,
};

// 쿠키 이름에 포트를 접두사로 붙이는 헬퍼 함수
const getCookieNameWithPort = (name) => {
	if (currentDomain.includes('localhost') && currentPort) {
		// 이미 포트 접두사가 붙어있는지 확인
		if (name.startsWith(`${currentPort}_`)) {
			return name;
		}
		return `${currentPort}_${name}`;
	}
	return name;
};

const removeCookieNamePort = (name) => {
	if (
		currentDomain.includes('localhost') &&
		currentPort &&
		name.startsWith(`${currentPort}_`)
	) {
		return name.substring(`${currentPort}_`.length);
	}
	return name;
};

export const set = (name, value, option = DEFAULT_OPTIONS) => {
	const effectiveName = getCookieNameWithPort(name);
	if (value !== undefined) {
		return cookies.set(effectiveName, value, {
			...option,
		});
	}
};

export const get = (name, option = DEFAULT_OPTIONS) => {
	const effectiveName = getCookieNameWithPort(name);
	return cookies.get(effectiveName, { ...option });
};

export const remove = (name, option = DEFAULT_OPTIONS) => {
	const effectiveName = getCookieNameWithPort(name);
	if (effectiveName !== getCookieNameWithPort('searchWordListHistory')) {
		return cookies.remove(effectiveName, { ...option });
	}
};

export const getAll = () => {
	const allCookies = cookies.getAll();
	const filteredCookies = {};

	// 현재 포트의 쿠키만 필터링
	for (let [cookieName, cookieValue] of Object.entries(allCookies)) {
		if (currentDomain === 'localhost' && currentPort) {
			// 현재 포트의 쿠키만 가져오기
			if (cookieName.startsWith(`${currentPort}_`)) {
				filteredCookies[cookieName] = cookieValue;
			}
		} else {
			// 프로덕션 환경에서는 모든 쿠키 반환
			filteredCookies[cookieName] = cookieValue;
		}
	}

	return filteredCookies;
};

export const removeAll = () => {
	let cookieAll = getAll();
	for (let cookie of Object.keys(cookieAll)) {
		// 이미 필터링된 쿠키들이므로 원래 이름으로 remove 호출
		const originalName = removeCookieNamePort(cookie);
		remove(originalName);
	}
};

export const refresh = () => {
	const cookieAll = getAll();
	const expiresAtStr = get('expiresAt');
	const now = Date.now();

	// 현재 시간과 기존 만료 시간 표시
	const currentExpiresAt = expiresAtStr ? Number(expiresAtStr) : now;
	const remainingTime = currentExpiresAt - now;
	const remainingSeconds = Math.floor(remainingTime / 1000);

	console.log('=== 세션 갱신 체크 ===');
	console.log(`현재 시간: ${new Date(now)}`);
	console.log(`기존 만료 시간: ${new Date(currentExpiresAt)}`);
	console.log(`남은 시간: ${remainingSeconds}초`);

	// 테스트용 설정
	// const RENEWAL_THRESHOLD_MS = 8 * 1000; // 8초 임계값 (만료 8초 전에 갱신)
	// const SESSION_DURATION_MS = 15 * 1000; // 15초로 세션 연장

	const RENEWAL_THRESHOLD_MS = 5 * 60 * 1000; // 5분
	const SESSION_DURATION_MS = 30 * 60 * 1000; // 30분

	console.log(`갱신 임계값: ${RENEWAL_THRESHOLD_MS / 1000}초`);
	console.log(`세션 연장 시간: ${SESSION_DURATION_MS / 1000}초`);

	// 갱신 조건: 임계값 이하로 남았거나 이미 만료된 경우에만 갱신
	if (currentExpiresAt > now && remainingTime > RENEWAL_THRESHOLD_MS) {
		console.log(
			`❌ 갱신 불필요 - 아직 ${remainingSeconds}초 남았음 (${
				RENEWAL_THRESHOLD_MS / 1000
			}초 이상)`,
		);
		return;
	}

	const newExpiresAt = now + SESSION_DURATION_MS;

	console.log('✅ 갱신 조건 충족!');
	console.log(`갱신 전 만료 시간: ${new Date(currentExpiresAt)}`);
	console.log(`갱신 후 만료 시간: ${new Date(newExpiresAt)}`);

	// 쿠키 갱신 시점에서 정확한 maxAge 계산
	const cookieSetTime = Date.now();
	const secondsUntilExpiry = Math.ceil((newExpiresAt - cookieSetTime) / 1000);

	console.log(`쿠키 설정 시점: ${new Date(cookieSetTime)}`);
	console.log(`목표 만료 시점: ${new Date(newExpiresAt)}`);
	console.log(`계산된 maxAge: ${secondsUntilExpiry}초`);

	// 쿠키 갱신 로직
	for (let cookie of Object.keys(cookieAll)) {
		const cookieName = getCookieNameWithPort('searchWordListHistory');
		const expiresAtName = getCookieNameWithPort('expiresAt');

		// 특정 쿠키 제외
		if (cookie === cookieName || cookie === expiresAtName) {
			continue;
		}

		const originalName = removeCookieNamePort(cookie);

		set(originalName, cookieAll[cookie], {
			...DEFAULT_OPTIONS,
			maxAge: secondsUntilExpiry,
		});
	}

	// expiresAt 쿠키도 동일한 만료 시간으로 설정
	set('expiresAt', newExpiresAt.toString(), {
		...DEFAULT_OPTIONS,
		maxAge: secondsUntilExpiry,
	});

	console.log('🎉 세션 갱신 완료!');
	console.log(
		`다음 갱신 가능 시간: ${new Date(
			newExpiresAt - RENEWAL_THRESHOLD_MS,
		).toLocaleTimeString()}`,
	);
	console.log('========================');
};
